export default __webpack_public_path__ + "static/media/00.161a1693.jpg";